<template lang="pug">
    div(class="pa-4")
        v-row(v-if="!validCustomerVehicles && !showVehicleForm")
            v-col(cols="12")
                v-alert(dense type="warning" outlined justify="center")
                    | Please create a new vehicle before setting an appointment.
        
        div(v-show="showVehicleForm" class="pa-4")
            v-card.pa-4
                v-row
                    v-col(cols="12")
                        h3(class="subtitle-2") Vehicle Information
                v-row
                    v-col(cols="4")
                        v-text-field(
                            v-model="formVehicle.year"
                            label="Year *"
                            type="text"
                            clearable
                            :rules="[rules.required, rules.yearRule]"
                            validate-on-blur
                        )
                    v-col(cols="4")
                        v-text-field(
                            v-model="formVehicle.make"
                            label="Make *"
                            type="text"
                            clearable
                            :rules="[rules.required]"
                            validate-on-blur
                        )
                    v-col(cols="4")
                        v-text-field(
                            v-model="formVehicle.model"
                            label="Model *"
                            type="text"
                            clearable
                            :rules="[rules.required]"
                            validate-on-blur
                        )
                v-row
                    v-col(cols="12")
                        v-text-field(
                            v-model="formVehicle.vin"
                            label="VIN *"
                            type="text"
                            clearable
                            counter="17"
                            :rules="[rules.vinRule, rules.required]"
                            validate-on-blur
                        )
                v-row
                    v-col.d-flex.justify-end
                        v-btn(color="success" :disabled="!vehicleEligibleToSave" :loading="isLoading" small outlined ripple @click="handleSaveVehicle")
                            v-icon mdi-content-save
                            | Save
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {
                formVehicle: {
                    year: null,
                    make: null,
                    model: null,
                    vin: null,
                    sid: null,
                },
                isFormLoading: false,
                rules: {
                    required: (value: any) => !!value || 'This field is required',
                    yearRule: (value: string) => {
                        if (!value) return true; // Let required rule handle empty values
                        const year = parseInt(value);
                        const currentYear = new Date().getFullYear();
                        return (year >= 1900 && year <= currentYear + 1) || 'Please enter a valid year';
                    },
                    vinRule: (value: string) => {
                        if (!value) return 'VIN is required';
                        return value.length === 17 || 'VIN must be exactly 17 characters';
                    },
                },
            }
        },
        methods: {
            handleSaveVehicle() {
                if (!this.formVehicle.year || !this.formVehicle.make || !this.formVehicle.model || !this.formVehicle.vin) {
                    this.showSnackbar("error", "All fields are required to save a new vehicle");
                    return;
                }

                this.isFormLoading = true;

                // Check if VIN already exists in customer vehicles
                const existingVehicle = this.customerVehicles?.find(
                    vehicle => this.formVehicle?.vin &&
                        vehicle.vin?.toLowerCase() === this.formVehicle?.vin.toLowerCase()
                );

                // Vehicle already exists, show message and close form
                if (existingVehicle) {
                    this.showSnackbar("warning", "Vehicle with this VIN already exists. Please select it from the dropdown.");
                    this.resetVehicleForm();
                    return;
                }

                // create new vehicle
                this.createCustomerVehicle(this.formVehicle);
                this.isFormLoading = false;
            },
            resetVehicleForm() {
                this.formVehicle = {
                    year: null,
                    make: null,
                    model: null,
                    vin: null,
                };
            },
        },
        computed: {
            isLoading() {
                return this.isVehicleSaving || this.isFormLoading;
            },
            validCustomerVehicles() {
                return this.customerVehicles?.length > 0;
            },
            vehicleEligibleToSave() {
                const { year, make, model, vin } = this.formVehicle;

                // Check if all required fields exist
                const hasRequiredFields = !!(year && make && model && vin);

                // Check if fields pass their validation rules
                const yearValid = this.rules.yearRule(year) === true;
                const vinValid = this.rules.vinRule(vin) === true;

                return hasRequiredFields && yearValid && vinValid;
            },
        },
        props: {
            customerVehicles: Array,
            createCustomerVehicle: Function,
            showSnackbar: Function,
            showVehicleForm: Boolean,
            isVehicleSaving: Boolean,
        },
    })
</script>